import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function LoadingSpinner({ className = '' }) {
  return (
    <div className={`loadingAnimation ${className}`}>
      <FontAwesomeIcon
        icon={faSpinnerThird}
        spin
        className="fastSpin"
        size="2x"
      />
    </div>
  );
}

export default LoadingSpinner;
